import { Injectable } from "@angular/core";

@Injectable()
export class ClipboardService {
  public copy(textToCopy: string) {
    // Create tmp element and append text to it.
    const copyElement = document.createElement("textarea");
    copyElement.appendChild(document.createTextNode(textToCopy));
    document.body.appendChild(copyElement);

    // Select the text to copy.
    const range = document.createRange();
    range.selectNode(copyElement);
    window.getSelection().removeAllRanges();
    window.getSelection().addRange(range);
    // Separate selection method is needed for Safari
    copyElement.setSelectionRange(0, copyElement.value.length);

    // Copy to clipboard and do cleanup.
    document.execCommand("copy");
    window.getSelection().removeAllRanges();
    copyElement.remove();
  }
}
